//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getOrderList, receipt } from '@/api/jianianhua'
export default {
  name: 'myexchange',
  props: {},
  data () {
    return {
      changelist: '',
      page: 1,
      rows: 8,
      moremsg: '点击加载更多',
      nomore: false
    }
  },
  created () { },
  mounted () {
    this.getlist()
  },
  methods: {
    getlist () {
      let _this = this
      getOrderList({
        accountid: this.$store.state.user.accountid,
        insertsource: 3, // 订购来源(1|积分商城)
        grouptype: '',
        page: this.page,
        rows: this.rows
      }).then(res => {
        if (res.returnValue.length > 0) {
          this.changelist = [...this.changelist, ...res.returnValue]
          this.moremsg = '点击加载更多'
          _this.nomore = false
        } else {
          this.moremsg = '没有更多了'
          _this.nomore = true
        }
      })
    },
    linkdetail (id) {
      this.$router.push({ name: 'jianianhuastampdetail', params: { id: id } })
    },
    examine (id) {
      console.log(id)
      this.$router.push({ name: 'jianianhualogistics', params: { id: id } })
    },
    certain (id) {
      var _this = this
      this.$vux.confirm.show({
        content: '请确认您已经收到商品！',
        onConfirm () {
          receipt({
            id: id
          }).then(res => {
            console.log('确认')
            if (res.success) {
              _this.$vux.alert.show({
                content: '确认收货成功',
                onHide () {
                  location.reload()
                }
              })
            }
          })
        }
      })
    },
    loadmore () {
      if (!this.nomore) {
        this.moremsg = '加载中...'
        this.page++
        this.getlist()
      }
    }
  }
}
